import {GraphQLService} from "./graphql.service";
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Language} from "../models/language.model";

@Injectable()
export class LanguageService extends GraphQLService<Language> {

  languages: Language[]

  constructor(
    http: HttpClient,
    snackBar: MatSnackBar
  ) {
    super(http, snackBar)
    this.initAvailableLanguages();
  }

  getFlag(code3: string | undefined) {
    const language = this.solveLanguage(code3)
    if (language) {
      return `https://purecatamphetamine.github.io/country-flag-icons/3x2/${language.code2?.toUpperCase()}.svg`
    } else {
      return ''
    }
  }

  getTranslationKey(code3: string | undefined): string {
    const language = this.solveLanguage(code3)
    if (!language) {
      return ''
    }
    return `product.book_languages.${language?.code3 || 'unknown'}`
  }

  solveLanguage(code3: string | undefined): Language | undefined {
    if (!this.languages) {
      return
    }
    return this.languages.find((lang) => lang.code3 === code3)
  }

  private getAvailableLanguages(): Observable<Language[]> {
    return this.findAll(`{ availableLanguages { code2 code3 i18n default counter } }`)
  }

  private initAvailableLanguages() {
    this.getAvailableLanguages().subscribe(
      (languages) => {
        this.languages = languages
      }
    )
  }

}
